import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { StyleValue } from "vue";

interface LinkedButtonProps {
  style?: StyleValue;
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkedButton',
  props: {
    style: null,
    url: null
  },
  emits: ["click"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['linked-button']),
    style: _normalizeStyle(__props.style),
    title: __props.url,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', __props.url)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 14, _hoisted_1))
}
}

})